import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Row, Col, Button, Input } from "reactstrap";
import { push } from "../../utils/navigation";
import { BASE_URL } from "../../constants";
import {
  createOilType,
  getOilTypeDetails,
  updateOilType,
} from "../../actions/globalSettingAction";
import { withRouter } from '../../utils/withRouter';

const OilTypeControl = ({ dispatch, ...props }) => {
  const [isEditMode, setIsEditMode] = useState(false);
  const [item, setItem] = useState({
    id: 0,
    code: "",
    name: "",
    isActive: false,
  });

  useEffect(() => {
    if (props.id !== 0) {
      setIsEditMode(true);
      dispatch(getOilTypeDetails(props.id)).then((x) => {
        if (x.data) {
          setItem(x.data);
        }
      });
    }
  }, []);

  function goBack() {
    dispatch(push(`${BASE_URL}/global-settings`));
  }

  /**
   * @typedef InputEventTarget
   * @property {string} name
   * @property {string} type
   * @property {any} value
   * @property {boolean} checked
   *
   * @param {InputEventTarget} e
   */
  function handleChange(e) {
    setItem((s) => ({
      ...s,
      [e.name]: e.type === "checkbox" ? e.checked : e.value,
    }));
  }

  function saveItem() {
    if (isEditMode) {
      dispatch(updateOilType(props.id, item));
    } else {
      dispatch(createOilType(item)).then((x) => {
        if (x.data.ok) {
          goBack();
        }
      });
    }
  }

  return (
    <div className="container">
      <Row>
        <Col>
          <h4>
            {isEditMode ? "Edit" : "Create New"} Oil Type &nbsp;
            <Button color="seconday" onClick={goBack}>
              <i className="fa fa-mail-reply" />
            </Button>
          </h4>
        </Col>
      </Row>
      <Row>
        <Col>
          <div className="form-horizontal">
            <div className="form-group row">
              <label className="col-md-2 form-control-label" htmlFor="code">
                Code
              </label>
              <div className="col-md-6">
                <Input
                  type="text"
                  onChange={(e) =>
                    handleChange({ name: "code", value: e.target.value })
                  }
                  value={item.code}
                  name="code"
                  placeholder="Code"
                />
              </div>
            </div>
            <div className="form-group row">
              <label className="col-md-2 form-control-label" htmlFor="name">
                Name
              </label>
              <div className="col-md-6">
                <Input
                  type="text"
                  onChange={(e) =>
                    handleChange({ name: "name", value: e.target.value })
                  }
                  value={item.name}
                  name="Name"
                  placeholder="Name"
                />
              </div>
            </div>
            {isEditMode && (
              <div className="form-group row">
                <label
                  className="col-md-2 form-control-label"
                  htmlFor="isActive"
                >
                  Active
                </label>
                <div className="col-md-6" style={{
                  paddingLeft: "2.25rem"
                }}>
                  <Input
                    type="checkbox"
                    onChange={(e) =>
                      handleChange({
                        name: "isActive",
                        checked: e.target.checked,
                        type: "checkbox",
                      })
                    }
                    checked={item.isActive}
                    name="isActive"
                  />
                </div>
              </div>
            )}
            <div className="form-group row">
              <Button color="primary" onClick={saveItem}>
                <i className="fa fa-save" />
                &nbsp;Save
              </Button>
            </div>
          </div>
        </Col>
      </Row>
    </div>
  );
};

OilTypeControl.propTypes = {
  id: PropTypes.number,
};

const mapStateToProps = (state, props) => ({
  id: parseInt(props.routeParams.id) || 0,
});

const mapDispatchToProps = (dispatch) => {
  return {
    dispatch,
  };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(OilTypeControl));
